import { IKeHoachTuanCreateRequest } from "../../../model/request/ke-hoach/IKeHoachTuanCreateRequest";
import { IKeHoachTuan } from "../../../model/respone/ke-hoach/IKeHoachTuan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachTuanActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as IKeHoachTuan[],
  LOAD_ERRR: "",
  SHOW_QUICK_CREATE: false,

  SAVE_START: {} as IKeHoachTuanCreateRequest,
  SAVE_SUCCESS: undefined,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",
};
export const eKeHoachTuanActionIds = generateActionTypeIds(
  eKeHoachTuanActionsObj,
  "KE_HOACH_TUAN"
);
export type IKeHoachTuanActionTypes = IGenericActionType<
  typeof eKeHoachTuanActionsObj,
  "KE_HOACH_TUAN"
>;
